export const CONTACT_PERSONS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerContactPersonsUpdated";

export const CONTACT_PERSONS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerContactPersonsInvalidated";
export const ALL_CONTACT_PERSONS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.Partner.DocumentPartnerContactPersonsInvalidated";
